import React from 'react';

const QuerySnippet = ({ code }) => (
  <pre style={{ background: '#1e1e1e', color: '#d4d4d4', padding: '1em', borderRadius: '0.5rem', overflowX: 'auto' }}>
    {code}
  </pre>
);

export default QuerySnippet;